var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _circle, _line11, _line12, _line13, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 140",
    fill: "none",
    width: 200,
    height: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 16,
    x2: 28,
    y2: 100,
    stroke: "#D4D4D4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 100,
    x2: 176,
    y2: 100,
    stroke: "#D4D4D4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 36,
    x2: 28,
    y2: 36,
    stroke: "#D4D4D4",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 56,
    x2: 28,
    y2: 56,
    stroke: "#D4D4D4",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 76,
    x2: 28,
    y2: 76,
    stroke: "#D4D4D4",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 36,
    x2: 176,
    y2: 36,
    stroke: "#E5E5E5",
    strokeWidth: 1,
    strokeDasharray: "4 3"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 56,
    x2: 176,
    y2: 56,
    stroke: "#E5E5E5",
    strokeWidth: 1,
    strokeDasharray: "4 3"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 76,
    x2: 176,
    y2: 76,
    stroke: "#E5E5E5",
    strokeWidth: 1,
    strokeDasharray: "4 3"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 100,
    x2: 60,
    y2: 104,
    stroke: "#D4D4D4",
    strokeWidth: 1.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 100,
    x2: 96,
    y2: 104,
    stroke: "#D4D4D4",
    strokeWidth: 1.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 132,
    y1: 100,
    x2: 132,
    y2: 104,
    stroke: "#D4D4D4",
    strokeWidth: 1.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: 100,
    x2: 168,
    y2: 104,
    stroke: "#D4D4D4",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 58,
    r: 18,
    stroke: "#A3A3A3",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 50,
    x2: 100,
    y2: 66,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 58,
    x2: 108,
    y2: 58,
    stroke: "#A3A3A3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: 71,
    x2: 122,
    y2: 80,
    stroke: "#A3A3A3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 122,
    textAnchor: "middle",
    fontFamily: "'Inter', -apple-system, sans-serif",
    fontSize: 11,
    fill: "#737373"
  }, "\u9078\u64C7\u7BC4\u570D\u5167\u7121\u8CC7\u6599")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.a5f7250e8f0403ea52f5ee4fb063d6d7.svg";
export { ForwardRef as ReactComponent };